(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

function initGaveroShippingFAQs() {
  document.querySelectorAll('div.gavero-shipping__faq').forEach((item) => {
    const title = item.querySelector('.gavero-shipping__faq-title');
    const answer = item.querySelector('.gavero-shipping__answer');
    if (!title || !answer) return;
    const details = document.createElement('details');
    details.className = 'gavero-shipping__faq';
    const summary = document.createElement('summary');
    summary.textContent = title.textContent;
    details.append(summary, answer);
    item.replaceWith(details);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGaveroShippingFAQs, { once: true });
} else {
  initGaveroShippingFAQs();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libellula-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ll-cta');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#') || href.length < 2) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    history.replaceState(null, '', href);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    

function initGaveroHelp() {
  const root = document.querySelector('.gavero-help');
  if (!root || root.dataset.initialized) return;
  const input = root.querySelector('#gavero-help-search');
  if (!input) return;
  root.dataset.initialized = 'true';
  const articles = [...root.querySelectorAll('.gavero-help__article')];
  const topics = root.querySelector('.gavero-help__topics');
  const heading = root.querySelector('.gavero-help__answers-title');
  const status = root.querySelector('.gavero-help__status');
  const reset = root.querySelector('.gavero-help__reset');
  const empty = root.querySelector('.gavero-help__empty');
  const normalize = (value) => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
  const aliases = {retoure:'rucksendung',retouren:'rucksendung',zuruckschicken:'rucksendung',lieferkosten:'versandkosten'};
  const keywords = {rueckgabe:'Retoure Rücksendung Rückgabe Umtausch Rückerstattung',versand:'Versand Lieferung Lieferzeit Versandkosten Tracking',pflege:'Schmuck Pflege Material Edelstahl Silber Gold Vergoldung',groessen:'Größe Größen Ringgröße Passform',garantie:'Reklamation Garantie Defekt beschädigt Mangel',bestellungen:'Bestellung ändern Lieferadresse Bestellung Kundenkonto',gutscheine:'Gutschein Geschenkgutschein Rabatt Rabattcode',konto:'Konto Kundenkonto Newsletter anmelden abmelden',kontakt:'Kontakt Kundenservice E-Mail WhatsApp Hilfe'};
  const index = new Map(articles.map(article => [article,normalize(article.textContent+' '+(keywords[article.dataset.helpTopic] || ''))]));
  let currentTopic = '';
  function render() {
    const raw = input.value.trim();
    const words = normalize(raw).split(/\s+/).filter(Boolean).map(word=>aliases[word] || word);
    const active = words.length > 0 || currentTopic !== '';
    let count = 0;
    articles.forEach(article => {
      const show = words.length ? words.every(word=>index.get(article).includes(word)) : currentTopic ? article.dataset.helpTopic === currentTopic : article.dataset.helpPopular === 'true';
      article.hidden = !show;
      if (!show) article.open = false;
      if (show) count++;
    });
    topics.hidden = active;
    reset.hidden = !active;
    empty.hidden = count !== 0;
    heading.textContent = words.length ? 'Suchergebnisse' : currentTopic ? root.querySelector('[data-help-title][data-help-topic="'+currentTopic+'"]').dataset.helpTitle : 'Die häufigsten Fragen';
    status.textContent = active ? count+' '+(count===1 ? 'Antwort gefunden' : 'Antworten gefunden') : '';
  }
  input.addEventListener('input',()=>{ currentTopic=''; render(); });
  root.querySelector('.gavero-help__search').addEventListener('submit',event=>{
    event.preventDefault();
    render();
    root.querySelector('.gavero-help__answers').scrollIntoView({block:'start'});
  });
  root.querySelectorAll('a[data-help-topic]').forEach(card=>card.addEventListener('click',event=>{
    event.preventDefault();
    currentTopic=card.dataset.helpTopic;
    input.value='';
    render();
    root.querySelector('.gavero-help__answers').scrollIntoView({block:'start'});
    heading.setAttribute('tabindex','-1');
    heading.focus({preventScroll:true});
  }));
  reset.addEventListener('click',()=>{
    input.value='';
    currentTopic='';
    render();
    input.focus({preventScroll:true});
    root.querySelector('.gavero-help__hero').scrollIntoView({block:'start'});
  });
  render();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initGaveroHelp,{once:true});
else initGaveroHelp();


  } catch(e) { console.error(e); }
})();
})();
